import styled from "styled-components";

export const CmpNumberInput = styled.div`
  /* background-color: var(--white);
  border-radius: 10px;
  padding: 13px 10px 10px 10px; */
  h5 {
    font-family: "Nunito Bold";
  }
  i {
    margin-left: 5px;
  }
  .selection-container {
    position: relative;
    &__number-icon {
      position: absolute;
      z-index: 1;
      right: 0;
      margin: 3px 10px 3px 0;
      color: #878792;
      font-size: 20px;
    }
  }
  .input-container {
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type="number"] {
      -moz-appearance: textfield;
    }
  }
`;

export const SelectorFormDiv = styled.div`
  background-color: var(--white);
  border-radius: 10px;
  box-shadow: ${({ boxShadow }) =>
    boxShadow ? "0px 3px 6px var(--box-shadow)" : ""};
  padding: ${({ boxShadow }) => (boxShadow ? "10px 15px" : "")};
  i {
    margin-left: 5px;
  }
  .date-selector {
    &-title {
      color: var(--blue-dark-color);
      font-size: 10px;
      font-family: "Nunito Sans ExtraBold";
      margin-bottom: 5px;
    }
  }
`;

export const SelectorForm = styled.div`
  background-color: var(--white);
  z-index: 100;
  width: 100%;
  /* padding: 5px 0 10px; */
  .progression-free-survival-form {
    &-date {
      margin: 10px 0 10px 0;
      display: flex;
      &-icon {
        color: var(--blue-color);
        margin-top: 2px;
      }
      &-text {
        font-family: "Nunito";
        margin-left: 10px;
      }
    }
    &-buttons {
      display: flex;
      justify-content: start;
    }
    &-button {
      width: 100px;
    }
  }
`;
